import { createFileRoute } from '@tanstack/react-router';

import { FaqPage } from '@/features/marketing/pages/faq';

export const Route = createFileRoute('/faq')({ component: FaqPage });
